// src/app/router/RequireAdmin.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useSubscription } from "../hooks/useSubscription";

const RequireAdmin = () => {
  const { isAdmin, loading } = useSubscription();

  if (loading) return null; // or <Spinner />

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireAdmin;